// extracted by mini-css-extract-plugin
export default {"btnContact":"Contactus_btnContact__hr5kH","para":"Contactus_para__-373L","heading":"Contactus_heading__OtiWz"};